<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <!-- table format-->
    <div class="col-lg-12">
      <div class="page-breadcrumb">
         <ul class="page-breadcrumb__trail">
            <li><a>Manage</a></li>
            <li><a>User Setting</a></li>
            <li><a>Routes</a></li>
          </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="../../../../assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
      <div class="panel panel-default">
        <div class="screen_heading_div">
          <span>Routes</span>
          <img src="../../../../../../assets/images/New_Icons/refresh.svg" title="Refresh" (click)="ngOnInit()">
        </div>
        <div class="search_cum_icons_button_container">
          <div class="search-div">
            <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
            <input type="text" (keyup)="applySearch()" [(ngModel)]="search" name="search" autocomplete="off"
                   placeholder="Search by product, micro, feature name etc..">
          </div>
          <div class="add-button-container" (click)="openForm()">
            <button class="button">
              <span class="icon"><img src="../../../../../../assets/images/New_Icons/plus-icon.svg"></span>
              <span class="text">Add New</span>
            </button>
          </div>
        </div>
        <div *ngIf="!responseLoader">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>
        
        <div class="panel-body table-responsive" *ngIf="responseLoader">
          <table class="table table-bordered table-striped routerstable" cellspacing=" 0" width="100%">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Product Name</th>
                <th>Micro Service Name</th>
                <th>Feature Name</th>
                <th>Screen Name</th>
                <th>Status</th>
                <th style="width:100px">End Point URL</th>
                <th>Updated Date & Time</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr class="routerssearch routeralign" *ngFor="let list of routesList; let i = index">
                <td>{{i+1}}</td>
                <td>{{
                    list && list.feature && list.feature[0] && list.feature[0].product && list.feature[0].product[0]
                    && list.feature[0].product[0].name
                  }}
                </td>
                <td>{{ list && list.microService }}</td>
                <td>{{ list && list.feature && list.feature[0] && list.feature[0].name }}</td>
                <td>{{
                    list && list.feature && list.feature[0] && list.feature[0].screen && list.feature[0].screen[0] &&
                    list.feature[0].screen[0].name
                  }}
                </td>
                <td>{{ list && list.status }}</td>
                <td style="width:100px">{{ list && list.url }}</td>
                <td>{{ list && list.updatedAt | date: "dd MMM yyyy HH:mm:ss a"}}</td>
                <td (click)="getRouteById(list.id)" data-toggle="modal" data-target="#addRouterpopup"
                    class="editicon itemtypeleftRecCls"><span title="Edit"><i class="fa fa-edit"></i></span></td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="listLoader" class="loader-div">
            <div class="adjust">
              <div class="loader2 list-loader"></div>
            </div>
          </div>
          <div *ngIf="noList && responseLoader" class="noDataFoundMessage" style="margin-top: 30px;">No Data Available</div>
        </div>
      </div>
      <!-- END BASIC TABLE SAMPLE -->

       <div class="dynamic-form-wrapper"
          [ngClass]="{
            'floating-panel': formFieldCount <= 7,
            'slide-in-overlay': formFieldCount > 7
          }"
          *ngIf="showForm">

        <div class="popup-wrapper">
          
          <button type="button" class="popup-close-beside" (click)="closeForm()" title="Close">
            &times;
          </button>

          <!-- Actual Popup -->
          <div [ngClass]="{
              'form-container-panel': formFieldCount > 7,
              'popup-inner': formFieldCount <= 7
            }">

            <form [formGroup]="registerForm" novalidate>
              
              <div class="form-header">
                <div class="form-title">Activity</div>
                <button class="add-update-submit-button" (click)="addUpdateRoute()" [disabled]="routesDoubleClick">
                  <span class="icon"><img src="../../../../assets/images/New_Icons/tick-icon.svg"></span>
                  <span class="text">{{ submitButton ? 'Submit' : 'Update'}}</span>
                </button>
              </div>

              <div class="form-container">
                <!--Product name-->
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Product Name</mat-label>
                  <mat-select [(ngModel)]="product.name" name="product" formControlName="product"
                    autocomplete="off" placeholder="Enter activity name">
                    <mat-option [value]="undefined" disabled>Select Product</mat-option>
                    <mat-option value="AQU">AQU</mat-option>
                    <mat-option value="BLUBAY">BLUBAY</mat-option>
                    <mat-option value="BH">BLUHATCH</mat-option>
                  </mat-select>
                  <mat-error *ngIf="(f.product.dirty || f.product.touched || formSubmitted) && f.product.hasError('required')">
                    Required
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Micro Service Name</mat-label>
                  <mat-select [(ngModel)]="route.microService" name="microservice" formControlName="microService">
                    <mat-option [value]="undefined" disabled>Select Micro Service Name</mat-option>
                    <mat-option value="AQU">AQU</mat-option>
                    <mat-option value="BLUBAY">Blubay</mat-option>
                    <mat-option value="GATEWAY">Gateway</mat-option>
                    <mat-option value="TRADINGCOMMUNITY">Trading Community</mat-option>
                    <mat-option value="BH">BluHatch</mat-option>
                    <mat-option value="MMS">MMS</mat-option>
                    <mat-option value="PUSHNOTIFICATION">Push Notification</mat-option>
                  </mat-select>
                  <mat-error *ngIf="(f.microService.dirty || f.microService.touched || formSubmitted) && f.microService.hasError('required')">
                    Required
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Screen Name</mat-label>
                  <mat-select [(ngModel)]="screen.name" name="screenname" formControlName="screen">
                    <mat-option [value]="undefined" disabled>Select Screen Name</mat-option>
                    <mat-option *ngFor="let screen of screens" [value]="screen.name">
                      {{ screen.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="(f.screen.dirty || f.screen.touched || formSubmitted) && f.screen.hasError('required')">
                    Required
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Feature Name</mat-label>
                  <mat-select [(ngModel)]="feature.name" name="featurename" formControlName="feature">
                    <mat-option [value]="undefined" disabled>Select Feature Name</mat-option>
                    <mat-option *ngFor="let feature of features" [value]="feature.name">
                      {{ feature.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="(f.feature.dirty || f.feature.touched || formSubmitted) && f.feature.hasError('required')">
                    Required
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Function Name</mat-label>
                  <mat-select [(ngModel)]="function.name" name="functionname" formControlName="function">
                    <mat-option [value]="undefined" disabled>Select Function Name</mat-option>
                    <mat-option *ngFor="let function of functions" [value]="function.name">
                      {{ function.name }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="(f.function.dirty || f.function.touched || formSubmitted) && f.function.hasError('required')">
                    Required
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Status</mat-label>
                  <mat-select [(ngModel)]="route.status" name="status" formControlName="status">
                    <mat-option [value]="undefined" disabled>Select Status</mat-option>
                    <mat-option value="Active">Active</mat-option>
                    <mat-option value="Inactive">Inactive</mat-option>
                    <mat-option value="In Progress">In Progress</mat-option>
                  </mat-select>
                  <mat-error *ngIf="(f.status.dirty || f.status.touched || formSubmitted) && f.status.hasError('required')">
                    Required
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>URL</mat-label>
                  <input
                    matInput
                    type="text"
                    name="url"
                    [(ngModel)]="route.url"
                    autocomplete="off"
                    placeholder="Enter URL"
                    formControlName="url"
                  />
                  <mat-error *ngIf="(f.url.dirty || f.url.touched || formSubmitted) && f.url.hasError('required')">
                    Required
                  </mat-error>
                </mat-form-field>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!--end add feature-->
    </div>
  </div>
</div>
